"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReliabilityDetailsInformation = void 0;
var React = _interopRequireWildcard(require("react"));
var _reliability = require("../services/reliability");
var _context = require("../shared/context");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useReliabilityDetailsInformation = _ref => {
  let {
    newbuildingId,
    houseId
  } = _ref;
  const {
    httpApi,
    logger
  } = React.useContext(_context.NewbuildingReliabilityContext);
  const [isLoading, setIsLoading] = React.useState(true);
  const [reliabilityDetails, setReliabilityDetails] = React.useState(null);
  const loadReliabilityDetails = React.useCallback(params => {
    setIsLoading(true);
    (0, _reliability.fetchReliability)({
      params,
      httpApi,
      logger
    }).then(reliability => {
      if (!reliability) {
        setIsLoading(false);
        setReliabilityDetails(null);
        return;
      }
      setReliabilityDetails(reliability);
      setIsLoading(false);
    });
  }, []);
  React.useLayoutEffect(() => {
    loadReliabilityDetails({
      newbuildingId,
      houseId
    });
  }, [newbuildingId, houseId]);
  return {
    reliabilityDetails,
    isLoading,
    loadReliabilityDetails
  };
};
exports.useReliabilityDetailsInformation = useReliabilityDetailsInformation;